// @flow
export const COLOR: string = 'color';
export const ENABLE: string = 'enable';
export const ERROR: string = 'flight_related_error';
export const CLEAR_ERROR: string = 'clear_flight_related_error'
export const RESOURCES_DETAILS: string = 'resources_details';
export const LOAD_RESOURCES_DETAILS: string = 'load_resources_details';
export const LOAD_RESOURCES_DETAILS_SUCCESS: string = 'load_resources_details_success';
export const LOAD_RESOURCES_DETAILS_FAIL: string = 'load_resources_details_fail';

export type ResourceDetail = {
  moduleColor: string,
  dateTime: string,
  flight: any,
  id: number,
  order: number,
  fileName: string,
  height: number,
  width: number
};



// WEBPACK FOOTER //
// ./src/types/resource.jsx